import { create } from "apisauce";

const production = "https://uis.diaeldin.com";
const development = "https://192.168.1.135";
// define the api

const api = create({
  baseURL: process.env.NODE_ENV === "production" ? production : development,
});

export default api;
